import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.indicacoesDesempenhoSemInviabilizados.length > 0 &&
      _vm.unidades.selecionado.length > 0
        ? _c(
            VRow,
            [
              _c(
                VCol,
                { attrs: { cols: "12" } },
                [
                  _c("pie-chart-indicacoes-desenvolvimento", {
                    attrs: {
                      "com-sub-piechart": _vm.comSubPiechart,
                      fonte: _vm.fontePieChart,
                      "indicacoes-desempenho":
                        _vm.indicacoesDesempenhoSemInviabilizados,
                      titulo: _vm.tituloPieChart,
                      "is-get-svg": _vm.isGetSvg,
                    },
                    on: { svg: (value) => (_vm.svg = value) },
                  }),
                  _vm.unidadesSemIndicacao.length > 0
                    ? _c(VRow, { staticClass: "justify-center" }, [
                        _c("p", { staticClass: "caption text-center" }, [
                          _vm._v(
                            " " + _vm._s(_vm.msgUnidadesSemIndicacao) + " "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _c(
                    VRow,
                    { staticClass: "justify-center" },
                    [_c("legenda-complexidade")],
                    1
                  ),
                  !_vm.isUmaUnidade
                    ? _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            [
                              _c(VDataTable, {
                                staticClass: "elevation-0",
                                attrs: {
                                  headers: _vm.headersResultados,
                                  items: _vm.indicacoesDesempenhoAgregado,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "top",
                                      fn: function () {
                                        return [
                                          _c(
                                            VRow,
                                            { staticClass: "mb-2" },
                                            [
                                              _c(
                                                VToolbar,
                                                { attrs: { flat: "" } },
                                                [
                                                  _c(VToolbarTitle, [
                                                    _c(
                                                      "h2",
                                                      {
                                                        staticClass:
                                                          "title primary--text text--darken-1 text-no-wrap",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.tituloTabelaResultados
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: `body.append`,
                                      fn: function () {
                                        return [
                                          _c(
                                            "tr",
                                            [
                                              _c("td"),
                                              _c(
                                                "td",
                                                { attrs: { align: "center" } },
                                                [
                                                  _c(
                                                    "strong",
                                                    {
                                                      staticClass:
                                                        "subtitle-2 grey--text text--darken-2",
                                                    },
                                                    [_vm._v("TOTAL")]
                                                  ),
                                                ]
                                              ),
                                              _vm._l(
                                                _vm.totalIndicacoes,
                                                function (total, i) {
                                                  return _c(
                                                    "td",
                                                    {
                                                      key: i,
                                                      attrs: {
                                                        align: "center",
                                                      },
                                                    },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(_vm._s(total)),
                                                      ]),
                                                    ]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isUmaUnidade
                    ? _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            [
                              _c(VDataTable, {
                                staticClass: "elevation-0",
                                attrs: {
                                  headers: _vm.headersResultados,
                                  items: _vm.indicacoesDesempenhoAgregado,
                                  "disable-pagination": "",
                                  "hide-default-footer": "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "top",
                                      fn: function () {
                                        return [
                                          _c(
                                            VRow,
                                            { staticClass: "mb-2" },
                                            [
                                              _c(
                                                VToolbar,
                                                { attrs: { flat: "" } },
                                                [
                                                  _c(VToolbarTitle, [
                                                    _c(
                                                      "h2",
                                                      {
                                                        staticClass:
                                                          "title primary--text text--darken-1 text-no-wrap",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.tituloTabelaResultados
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3177789889
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isUmaUnidade
                    ? _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            [
                              _c("tabela-indicacao-desenvolvimento", {
                                attrs: {
                                  "indicacoes-desempenho":
                                    _vm.indicacoesDesempenhoSemInviabilizados,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        [
                          _c("tabela-indicacao-competencia-tecnica", {
                            attrs: {
                              "indicacoes-competencia":
                                _vm.indicacoesCompetencia,
                              titulo: _vm.tituloIndicacoesCompetenciaTecnica,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.resultadosInviabilizadosServidor.length > 0 &&
                  _vm.isUmaUnidade
                    ? _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            [
                              _c(VDataTable, {
                                staticClass: "elevation-0",
                                attrs: {
                                  headers: _vm.headerInviabilizadosServidor,
                                  items: _vm.resultadosInviabilizadosServidor,
                                  "disable-pagination": "",
                                  "hide-default-footer": "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "top",
                                      fn: function () {
                                        return [
                                          _c(
                                            VRow,
                                            { staticClass: "mb-2" },
                                            [
                                              _c(
                                                VToolbar,
                                                { attrs: { flat: "" } },
                                                [
                                                  _c(VToolbarTitle, [
                                                    _c(
                                                      "h2",
                                                      {
                                                        staticClass:
                                                          "title primary--text text--darken-1 text-no-wrap",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " DESEMPENHOS TÉCNICOS INVIABILIZADOS "
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3976709019
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.unidadesSemIndicacao.length > 0 && !_vm.isUmaUnidade
                    ? _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            [
                              _c(VDataTable, {
                                staticClass: "elevation-0",
                                attrs: {
                                  headers: _vm.headerInviabilizadosUnidade,
                                  items: _vm.unidadesSemIndicacao,
                                  "disable-pagination": "",
                                  "hide-default-footer": "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "top",
                                      fn: function () {
                                        return [
                                          _c(
                                            VRow,
                                            { staticClass: "mb-2" },
                                            [
                                              _c(
                                                VToolbar,
                                                { attrs: { flat: "" } },
                                                [
                                                  _c(VToolbarTitle, [
                                                    _c(
                                                      "h2",
                                                      {
                                                        staticClass:
                                                          "title primary--text text--darken-1 text-no-wrap",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " DESEMPENHOS TÉCNICOS INVIABILIZADOS (" +
                                                            _vm._s(
                                                              _vm.unidadesSemIndicacaoSiglas
                                                            ) +
                                                            ") "
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1809094511
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VRow,
                    { staticClass: "justify-end" },
                    [
                      _c(
                        VTooltip,
                        {
                          attrs: { "max-width": "400", top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      VBtn,
                                      _vm._g(
                                        {
                                          staticClass: "mr-2",
                                          attrs: { color: "success" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.getRelatorio()
                                            },
                                          },
                                        },
                                        on
                                      ),
                                      [
                                        _c(VIcon, [_vm._v("get_app")]),
                                        _vm._v(" BAIXAR PDF "),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3286038400
                          ),
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "Clique para baixar o relatório dos dados em formato PDF."
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.unidades.selecionado.length > 0
        ? _c(
            VRow,
            [
              _c(
                VCol,
                [
                  _c("app-alert", {
                    attrs: {
                      message:
                        "Não há desempenhos viabilizados na(s) unidade(s)",
                      icon: "info",
                      type: "info",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }